export const NAME = 'identity';

export const REQUEST_USER_IDENTITY_VERIFIED = 'REQUEST_USER_IDENTITY_VERIFIED';
export const RECEIVE_USER_IDENTITY_VERIFIED = 'RECEIVE_USER_IDENTITY_VERIFIED';
export const FAILURE_USER_IDENTITY_VERIFIED = 'FAILURE_USER_IDENTITY_VERIFIED';



// WEBPACK FOOTER //
// ./src/services/account/identity/constants.js